<template>
  <div class="movie-hall page">
    <van-nav-bar class="nav-bar newnavbar" :title="$t('tabbar2')" @click-right="toService">
      <template #right>
        <van-image src="img/mine/kf.png" width="35" height="35">
          <template v-slot:loading>
            <van-loading type="spinner" />
          </template>
        </van-image>
      </template>
    </van-nav-bar>
    <div style="padding: 10px; height: calc(100vh - 110px); overflow: auto;">
      <div class="sqdtitem" v-for="(v, i) in videolist" :key="i"
        style="color: #404040; padding: 20px; background: #fff; margin-bottom: 10px; border-radius: 10px;">
        <div style="margin-bottom: 10px;">{{ v.title }}</div>
        <div style="font-size: 12px;" v-html="v.content"></div>
        <!-- <div style="font-size: 12px; text-align: right;">
          {{ new Date(v.addtime * 1000).toLocaleDateString().replace(/\//g, "-") + " " + new
            Date(v.addtime * 1000).toTimeString().substr(0, 8) }}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videolist: [],
    };
  },
  created() {
    this.getVideoList();
  },
  methods: {
    formatRichText(html) {
      return html.replace(/<img/g, '<img style="max-width: 100%; min-width: 100%;"');;
    },
    getVideoList() {
      this.$httpNew({
        method: 'get',
        data: {},
        url: 'get_article'
      }).then(res => {
        res.data.map(v => {
          v.content = this.formatRichText(v.content);
        })
        this.videolist = res.data;
      })
    },
    toService() {
      this.$router.push({ path: '/customerservice' });
    },
  },
};
</script>

<style lang='less' scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.newnavbar {
  // background: linear-gradient(90deg, #7e5678, #e6c3a1);
  height: 100px;
  background: #000000;

}

.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.movie-hall {
  display: flex;
  flex-direction: column;
  bottom: 100px;
  background: #f2f2f5;
}

::v-deep .van-tabs__nav {
  // background: linear-gradient(to right, rgb(126, 86, 120), rgb(230, 195, 161));
  // background: linear-gradient(30deg, #7d76ef, #d63f8c);
}

::v-deep .van-tab {
  color: #ffffff;
  font-size: 30px;
}

::v-deep .van-tabs__line {
  bottom: 20px;
  width: 80px;
  height: 10px;
  border-radius: 8px;
  background-color: #c571cf;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.video_swiper {
  width: 100%;
  flex: 1;

  .swiper-slide {
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: 100%;
    justify-content: center;
    height: 100%;
    position: relative;
    transition-property: transform;
  }
}

.movie-list-tab {
  overflow: auto;
  height: 100%;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000;
  font-size: 35px;
}

.movie-list-tab .hot-recommend-div {
  height: 100%;
  margin: 10px auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100vw;
  //overflow: auto;
}

.movie-list-tab .hot-recommend-div .van-list {
  width: 100%;
}

.list-item {
  display: flex;
  width: calc(100% - 50px);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

.list-item .movie-list-item {
  width: calc(50% - 8px);
}

// .list-item .movie-list-item:nth-child(odd) {
//   margin-right: 20px;
// }

.movie-list-item .cover_img {
  border-radius: 10px;
  width: 335px;
  // height: 290px;
}

.movie-list-item {
  margin-bottom: -50px;
}

.list-item .movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 42px;
}

.list-item .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
  height: 60px;
}

.list-item .movie-list-item-bottom>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list-item .movie-list-item-bottom .movie-time-div .van-count-down {
  color: #fff;
}

.list-item .movie-list-item .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 180px;
  padding-left: 8px;
  font-size: 25px;
}

.list-item .movie-time-div {
  color: #fff;
  border-radius: 0 0 20px 20px;
  height: 35px;
}
</style>
